// extracted by mini-css-extract-plugin
export var bannerBar = "footer-module--banner-bar--24a45";
export var bannerClose = "footer-module--banner-close--6b112";
export var bannerHighlight = "footer-module--banner-highlight--96687";
export var bcorpLogo = "footer-module--bcorp-logo--b0aa3";
export var copyrightLinks = "footer-module--copyright-links--a3376";
export var linkMargin = "footer-module--link-margin--8fe4e";
export var logoImg = "footer-module--logo-img--6fbdd";